import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editLifelineAction = createAsyncThunk(
    'edit-lifeline',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/create-update/${data?.lifeline_id}`,{...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editlifelineSlice = createSlice({
    name: 'edit-lifeline',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editLifelineAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editLifelineAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editLifelineAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editlifelineReducer = editlifelineSlice.reducer    